module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('input', {
    ref: "idImgFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "6px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("选择文件")))]), _vm._v(" "), _c('div', {
    ref: "idImgPath",
    staticStyle: {
      "float": "left",
      "margin-top": "7px",
      "text-indent": "10px",
      "width": "350px",
      "height": "30px",
      "line-height": "30px",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "490px",
      "height": "272px",
      "margin-top": "10px",
      "border": "1px solid #bbbbbb",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('img', {
    ref: "idImgPan",
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "border": "0px solid red"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "12px",
      "margin-top": "3px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "490px",
      "height": "12px",
      "border-radius": "5px",
      "border": "1px solid #2a83cf",
      "margin-top": "6px",
      "display": "block",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "idProgBar",
    staticStyle: {
      "position": "absolute",
      "width": "0%",
      "height": "10px",
      "line-height": "10px",
      "border-radius": "5px",
      "background": "#b4ea74"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idProgCapt",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "10px",
      "line-height": "10px",
      "color": "#2a83cf",
      "text-align": "center",
      "font-size": "8px",
      "font-style": "italic"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("上传")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba297f24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/SourceNew.vue
// module id = 791
// module chunks = 1